// marketNarrativeEngine.js
// Market Narrative Validator (Read-only)

export function validateMarketNarrative({
  market,
  structure,
  zoneState,
  candles,
}) {
  if (!structure || !zoneState || !candles?.length) {
    return {
      valid: false,
      state: "WAITING",
      reason: "Structure or zone not available",
      level: null,
    };
  }

  const price = candles[candles.length - 1].close;

  // ===== BOOM RULES =====
  if (market === "BOOM") {
    if (structure.direction !== "BULLISH") {
      return {
        valid: false,
        state: "WAITING",
        reason: "Boom market allows only bullish BOS",
        level: structure.levelToWatch || structure.bosPrice,
      };
    }

    if (zoneState.type !== "DEMAND") {
      return {
        valid: false,
        state: "WAITING",
        reason: "Demand zone required before bullish BOS",
        level: null,
      };
    }

    if (zoneState.high >= price) {
      return {
        valid: false,
        state: "WAITING",
        reason: "Demand zone must be below current market price",
        level: zoneState.high,
      };
    }

    if (price <= zoneState.high && price >= zoneState.low) {
      return {
        valid: false,
        state: "RESET",
        reason: "Price returned into demand zone, narrative reset",
        level: zoneState.low,
      };
    }

    return {
      valid: true,
      state: "CONFIRMED",
      reason: "Bullish BOS with valid demand zone below price",
      level: structure.bosPrice,
    };
  }

  // ===== CRASH RULES =====
  if (market === "CRASH") {
    if (structure.direction !== "BEARISH") {
      return {
        valid: false,
        state: "WAITING",
        reason: "Crash market allows only bearish BOS",
        level: structure.levelToWatch || structure.bosPrice,
      };
    }

    if (zoneState.type !== "SUPPLY") {
      return {
        valid: false,
        state: "WAITING",
        reason: "Supply zone required before bearish BOS",
        level: null,
      };
    }

    if (zoneState.low <= price) {
      return {
        valid: false,
        state: "WAITING",
        reason: "Supply zone must be above current market price",
        level: zoneState.low,
      };
    }

    if (price <= zoneState.high && price >= zoneState.low) {
      return {
        valid: false,
        state: "RESET",
        reason: "Price returned into supply zone, narrative reset",
        level: zoneState.high,
      };
    }

    return {
      valid: true,
      state: "CONFIRMED",
      reason: "Bearish BOS with valid supply zone above price",
      level: structure.bosPrice,
    };
  }

  return {
    valid: false,
    state: "WAITING",
    reason: "Unknown market",
    level: null,
  };
}
